import { JobType, ReqPriority, ReqTerm, ReqType } from "../requirement-my-sales/modal";

export type TECIRecord = {
    id?: number;
    submissionId: number;
    ecI_StatusId: number;
    ecI_Date_Time: Date;
    timeZoneId: number;
    interviewProcessId: number;
    interviewrName?: string;
    client?: string;
    comment?: string;
}

export const EmptyECI: TECIRecord = {
    submissionId: 0,
    ecI_Date_Time: new Date(),
    ecI_StatusId: 0,
    interviewProcessId: 0,
    timeZoneId: 0,
}

export type TECI = {
    id: number;
    ecI_StatusId: number;
    ecI_Status: string;
    ecI_Status_IsPositive: boolean;
    ecI_Status_ReadyToNext: boolean;
    ecI_Date_Time: string;
    timeZoneId: number;
    timeZone: string;
    interviewrName?: string;
    client?: string;
    interviewProcessId: number;
    interviewProcess: string;
    comment?: string;
    submissionId: number;
    requirementId: number;
    jobTitle: string;
    vendorCompanyName: string;
    subVendorCompanyName?: string;
    endClient?: string;
    skillCategory: string;
    postedOn: string;
    salesManager: string
    recruiter: string;
    submital_Date: string;
    candidateId: number;
    candidateName: string;
    candidateEmail: string;
}

export type TECIFilter = {
    fromDate: Date | string | null;
    toDate: Date | string | null;
    requirementId: number | null;
    skillCategoryId: number | null;
    salesId: number | null;
    recruiterId: number | null;
}

export const EmptyECIFilter: TECIFilter = {
    fromDate: new Date(),
    toDate: new Date(),
    requirementId: null,
    skillCategoryId: null,
    salesId: null,
    recruiterId: null,
}
